// /frontend/src/forms/userFormFields.js

import province from '../utils/province.js';

export const userFormFields = [
  {
    name: 'fullName',
    label: 'Nome e Cognome',
    type: 'text',
    required: true,
    gridSpan: 12, 
    step: 0,
  },
  {
    name: 'email',
    label: 'Email',
    type: 'email',
    required: true,
    gridSpan: 12,
    step: 0,
  },
  {
    name: 'address',
    label: 'Indirizzo di Residenza',
    type: 'text',
    required: true,
    gridSpan: 8,
    step: 1,
  },
  {
    name: 'city',
    label: 'Citta di Residenza',
    type: 'text',
    required: true,
    gridSpan: 4,
    step: 1,
  },
  {
    name: 'province',
    label: 'Provincia di Residenza',
    type: 'select',
    required: true,
    gridSpan: 12,
    step: 1,
    options: province.map(p => ({ value: p.sigla, label: p.nome })),
  },
  {
    name: 'phone',
    label: 'Telefono',
    type: 'tel',
    required: true,
    gridSpan: 12,
    step: 1,
  },
  {
    name: 'birthDate',
    label: 'Data di Nascita',
    type: 'date',
    required: true,
    gridSpan: 6,
    step: 1,
  },
  {
    name: 'birthPlace',
    label: 'Luogo di Nascita',
    type: 'text',
    required: true,
    gridSpan: 6,
    step: 1,
  },
  {
    name: 'linkedin',
    label: 'Profilo LinkedIn (Opzionale)',
    type: 'text',
    required: false,
    gridSpan: 12,
    step: 1,
  },
  {
    name: 'categories',
    label: 'Aree di competenza',
    type: 'autocomplete',
    required: true,
    gridSpan: 12,
    step: 2,
    options: [], 
  },
  {
    name: 'courses',
    label: 'Corsi frequentati',
    type: 'autocomplete',
    required: true,
    gridSpan: 12,
    step: 2,
    options: [],
  },
  {
    name: 'education',
    label: 'Esperienze scolastiche professionali e personali (Opzionale)',
    type: 'textarea',
    required: false,
    gridSpan: 12,
    helperText: 'Descrivi le tue esperienze principali (es. Diploma, Corsi, etc.).',
    step: 2,
  },
  {
    name: 'desiredJob',
    label: 'Che lavoro cerco',
    type: 'textarea',
    required: false,
    gridSpan: 12,
    step: 2,
    helperText: 'Es. "Giardiniere specializzato", "Apprendista vivaista", etc.'
  },
  {
    name: 'resume',
    // --- UPDATED LABEL ---
    label: 'Carica CV (Opzionale - PDF, max 2MB)',
    type: 'file',
    required: false,
    gridSpan: 12,
    step: 2,
  },
];